type ReviewCopy = { quote: string; service: string; location: string; date: string }

type Reviews = {
  page: {
    eyebrow: string
    title: string
    description: string
    summary: string
    filterLabel: string
  }
  filters: { all: string; flowers: string; balloons: string; both: string }
  items: Record<string, ReviewCopy>
}

const en: Reviews = {
  page: {
    eyebrow: 'Reviews',
    title: 'What Our Clients Say',
    description:
      'Weddings, quinceañeras, birthdays and corporate events — here’s how our flowers and balloons made each day feel special.',
    summary: 'Based on 27 Google reviews',
    filterLabel: 'Filter reviews by service',
  },
  filters: { all: 'All reviews', flowers: 'Flowers', balloons: 'Balloons', both: 'Flowers + Balloons' },
  items: {
    r1: {
      quote:
        'She understood our colors immediately and the reception tables looked better than the inspiration photos we sent. Highly recommend!',
      service: 'Wedding Florals',
      location: 'Columbia, MD',
      date: 'March 2026',
    },
    r2: {
      quote:
        'The balloon decorations for my daughter’s party were amazing! The colors were perfect, they delivered early, and set everything up beautifully.',
      service: 'Themed Balloon Installation',
      location: 'Jessup, MD',
      date: 'February 2026',
    },
    r3: {
      quote:
        'For my quinceañera, we used both flowers and balloons. The combination was absolutely stunning and everyone kept complimenting the setup!',
      service: 'Flores & Globos Quinceañera',
      location: 'Laurel, MD',
      date: 'April 2026',
    },
    r4: {
      quote:
        'Set up my daughter’s quinceañera in under two hours and stayed to fix every detail. Truly professional.',
      service: 'Celebration Decorations',
      location: 'Laurel, MD',
      date: 'January 2026',
    },
    r5: {
      quote: 'Excellent decorator. Highly recommended for events and celebrations.',
      service: 'Google review',
      location: 'Maryland',
      date: '2025',
    },
    r6: {
      quote:
        'We order lobby arrangements every month. Always fresh, always on time, always beautiful.',
      service: 'Corporate Flowers',
      location: 'Jessup, MD',
      date: 'November 2025',
    },
    r7: {
      quote:
        'The pastel balloon garland for our baby shower was even softer and prettier in person. Guests couldn’t stop taking photos.',
      service: 'Baby Shower Balloons',
      location: 'Elkridge, MD',
      date: 'May 2026',
    },
    r8: {
      quote:
        'Last-minute birthday request on a Friday and she still built a full balloon arch by Saturday morning. Lifesaver.',
      service: 'Balloon Arch — Same Day',
      location: 'Columbia, MD',
      date: 'June 2026',
    },
    r9: {
      quote:
        'The charro theme for my son’s first birthday was perfect — the cream and gold balloons looked so elegant.',
      service: 'Themed Balloons',
      location: 'Laurel, MD',
      date: 'July 2026',
    },
    r10: {
      quote:
        'Balloons and flowers for our company anniversary, matched to our brand colors. Professional from quote to cleanup.',
      service: 'Corporate Celebration',
      location: 'Jessup, MD',
      date: 'August 2026',
    },
  },
}

const es: Reviews = {
  page: {
    eyebrow: 'Reseñas',
    title: 'Lo Que Dicen Nuestros Clientes',
    description:
      'Bodas, quinceañeras, cumpleaños y eventos corporativos — así nuestras flores y globos hicieron especial cada día.',
    summary: 'Basado en 27 reseñas de Google',
    filterLabel: 'Filtrar reseñas por servicio',
  },
  filters: { all: 'Todas', flowers: 'Flores', balloons: 'Globos', both: 'Flores + Globos' },
  items: {
    r1: {
      quote:
        'Entendió nuestros colores de inmediato y las mesas de la recepción quedaron mejor que las fotos de inspiración que enviamos. ¡Muy recomendada!',
      service: 'Flores de Boda',
      location: 'Columbia, MD',
      date: 'Marzo 2026',
    },
    r2: {
      quote:
        '¡La decoración de globos para la fiesta de mi hija fue increíble! Los colores perfectos, llegaron temprano y lo instalaron todo hermoso.',
      service: 'Instalación Temática de Globos',
      location: 'Jessup, MD',
      date: 'Febrero 2026',
    },
    r3: {
      quote:
        'Para mi quinceañera usamos flores y globos. ¡La combinación quedó espectacular y todos elogiaron la decoración!',
      service: 'Quinceañera Flores y Globos',
      location: 'Laurel, MD',
      date: 'Abril 2026',
    },
    r4: {
      quote:
        'Montó la quinceañera de mi hija en menos de dos horas y se quedó a corregir cada detalle. Muy profesional.',
      service: 'Decoración de Celebraciones',
      location: 'Laurel, MD',
      date: 'Enero 2026',
    },
    r5: {
      quote: 'Excelente decoradora. Muy recomendada para eventos y celebraciones.',
      service: 'Reseña de Google',
      location: 'Maryland',
      date: '2025',
    },
    r6: {
      quote:
        'Pedimos arreglos para la recepción cada mes. Siempre frescos, siempre a tiempo, siempre hermosos.',
      service: 'Flores Corporativas',
      location: 'Jessup, MD',
      date: 'Noviembre 2025',
    },
    r7: {
      quote:
        'La guirnalda de globos pastel para nuestro baby shower fue aún más linda en persona. Los invitados no paraban de tomar fotos.',
      service: 'Globos para Baby Shower',
      location: 'Elkridge, MD',
      date: 'Mayo 2026',
    },
    r8: {
      quote:
        'Pedido de cumpleaños de último momento un viernes y aun así armó un arco completo para el sábado en la mañana.',
      service: 'Arco de Globos — Mismo Día',
      location: 'Columbia, MD',
      date: 'Junio 2026',
    },
    r9: {
      quote:
        'El tema charro para el primer cumpleaños de mi hijo quedó perfecto — los globos crema y oro se veían muy elegantes.',
      service: 'Globos Temáticos',
      location: 'Laurel, MD',
      date: 'Julio 2026',
    },
    r10: {
      quote:
        'Globos y flores para el aniversario de nuestra empresa, con los colores de nuestra marca. Profesionales de principio a fin.',
      service: 'Celebración Corporativa',
      location: 'Jessup, MD',
      date: 'Agosto 2026',
    },
  },
}

export const reviews = { en, es }
